


















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Budget {
    campaign: {
        formattedWeek: string;
        startDate: string;
        endDate: string;
    };
}

@Component({ components: { SimpleText } })
export default class Name extends Vue {
    @Prop( { default: null }) public budget !: Budget;

    public static getNeededFields(): string[] {
        return [
            "budget.campaign.formattedWeek",
            "budget.campaign.startDate",
            "budget.campaign.endDate",
        ];
    }
}
